var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 23.617l8-8.142 8 8.142V28.5l-8-8.142L0 28.5v-4.883zM16 .007v20.351l-3.204-3.253v-8.95L8 13.03 3.198 8.154v8.95L0 20.353V.006l8 8.148L16 0v.006z","fill":"#0E1318"}));
}

Logo.defaultProps = {"width":"16","height":"29","fill":"none"};

module.exports = Logo;

Logo.default = Logo;
